export default __webpack_public_path__ + "static/artificial-contract-builder-tool-72cec8c88c25df65614804a5cd99820f.png";